import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { locale } from './locale';
import i18n from './i18n';
import { merge } from 'lodash';
import { preset } from '../preset';
import { PERSISTEDSTATE_KEY } from '../constants';

Vue.use(Vuetify);

// usersetting 에 정보를 참조하여 지정하며, 정보가 존재하지 않을 경우 dark 를 기본으로 지정함.
const definedTheme = ((JSON.parse(window.localStorage.getItem(PERSISTEDSTATE_KEY.USER) || '{}').common || {}).user || {}).theme || 'dark';

// vuetify 의 theme 는 isDark 를 통해 여부만을 판단하므로,
// theme 의 이름으로 판별하기 위한 별도의 정보를 저장함.
Vue.prototype.$vuetify_theme = Object.keys(preset.theme.themes).reduce((acc, item) => {
  acc[item] = item == definedTheme;
  return acc;
}, {});

const vuetify = (async () => {
  const vueI18n = await i18n;
  const options = {
    lang: {
      t: (key, ...params) => vueI18n.t(key, params),
      current: locale,
    },
    theme: { [definedTheme]: true },
  };
  return new Vuetify({
    ...merge(options, preset),
  });
})();

export default vuetify;
